import { DATADOG_ACTIONS } from '@app/app-constants'
import { datadogRum } from '@datadog/browser-rum'

const isDev = import.meta.env?.MODE === 'development' || process.env.NODE_ENV === 'development'

export const logger = {
  info: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    if (isDev) console.info('[INFO]', ...args)
  },
  warn: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    if (isDev) console.warn('[WARN]', ...args)
  },
  error: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    if (isDev) console.error('[ERROR]', ...args)
  },
}

export type DataDogAction = (typeof DATADOG_ACTIONS)[keyof typeof DATADOG_ACTIONS]
export const logDataDogAction = (action: DataDogAction, context?: object) => {
  datadogRum.addAction(action, context)
}
